import React from "react";
import { AbnormalVehicleInfo } from "../model/Report";
import WarningMessageInfoDefine from '../assets/define/WarningMessage.json';
import { VehicleType01Image } from "../components/vehicleTypeImages/VehicleType01Image";
import { VehicleType02Image } from "../components/vehicleTypeImages/VehicleType02Image";
import { VehicleType03Image } from "../components/vehicleTypeImages/VehicleType03Image";
import { VehicleType04Image } from "../components/vehicleTypeImages/VehicleType04Image";
import { VehicleType05Image } from "../components/vehicleTypeImages/VehicleType05Image";
import { VehicleType06Image } from "../components/vehicleTypeImages/VehicleType06Image";
import { VehicleType07Image } from "../components/vehicleTypeImages/VehicleType07Image";
import { VehicleType08Image } from "../components/vehicleTypeImages/VehicleType08Image";
import { VehicleType10Image } from "../components/vehicleTypeImages/VehicleType10Image";
import { VehicleType11Image } from "../components/vehicleTypeImages/VehicleType11Image";


const sysStatusString = ["テレマティクス", "ヤード", "運転者通知"];
export function sysStatusToString(sysStatus:string) {
    return sysStatus !== '' && !isNaN(Number(sysStatus)) ? sysStatusString[Number(sysStatus)] : '';
}

export function sysStatusToCode(sysStatusStr:string) {
    return sysStatusString.indexOf(sysStatusStr);
}

export const roles = {
    'sys_admin': 1,
    'admin_admin': 2,
    "partner_admin": 3,
    "client_admin": 4,
    "vehicle_admin": 6
};

const LATERAL_POSITION_MAP = [
    {
        name: "3軸10本"
    },
    {
        name: "4軸12本"
    },
    {
        name: "3軸8本"
    },
    {
        name: "2軸4本"
    },
    {
        name: "2軸6本"
    },
    {
        name: "3軸6本"
    },
    {
        name: "3軸8本"
    },
    {
        name: "4軸14本"
    },
    {
        name: "4軸12本"
    },
    {
        name: "3軸12本"
    },
    {
        name: "2軸8本"
    }
];



const TIRE_POSITION_MAP: Record<string, number>[] = [
    {"00L0": 1, "00R0": 2, "01L0": 3, "01L1": 4, "01R1": 5, "01R0": 6, "02L0": 7, "02L1": 8, "02R1": 9, "02R0": 10 }, // 3軸10本
    {"00L0": 1, "00R0": 2, "01L0": 3, "01R0": 4, "02L0": 5, "02L1": 6, "02R1": 7, "02R0": 8, "03L0": 9, "03L1": 10, "03R1": 11, "03R0": 12 }, // 4軸12本
    {"00L0": 1, "00R0": 2, "01L0": 3, "01R0": 4, "02L0": 5, "02L1": 6, "02R1": 7, "02R0": 8 }, // 3軸8本(3軸目4本)
    {"00L0": 1, "00R0": 2, "01L0": 3, "01R0": 4 }, // 2軸4本
    {"00L0": 1, "00R0": 2, "01L0": 3, "01L1": 4, "01R1": 5, "01R0": 6 }, // 2軸6本
    {"00L0": 1, "00R0": 2, "01L0": 3, "01R0": 4, "02L0": 5, "02R0": 6 }, // 3軸6本
    {"00L0": 1, "00R0": 2, "01L0": 3, "01L1": 4, "01R1": 5, "01R0": 6, "02L0": 7, "02R0": 8 }, // 3軸8本(2軸目4本)
    {"00L0": 1, "00R0": 2, "01L0": 3, "01L1": 4, "01R1": 5, "01R0": 6, "02L0": 7, "02L1": 8, "02R1": 9, "02R0": 10, "03L0": 11, "03L1": 12, "03R1": 13, "03R0": 14 }, // 4軸14本
    {"00L0": 1, "00R0": 2, "01L0": 3, "01L1": 4, "01R1": 5, "01R0": 6, "02L0": 7, "02L1": 8, "02R1": 9, "02R0": 10, "03L0": 11, "03R0": 12 }, // 4軸12本(4軸目2本)
    {"00L0": 1, "00L1": 2, "00R1": 3, "00R0": 4, "01L0": 5, "01L1": 6, "01R1": 7, "01R0": 8, "02L0": 9, "02L1": 10, "02R1": 11, "02R0": 12 }, // 3軸12本(トレーラー)
    {"00L0": 1, "00L1": 2, "00R1": 3, "00R0": 4, "01L0": 5, "01L1": 6, "01R1": 7, "01R0": 8 } // 2軸8本(トレーラー)
]

export function vehicleTypeToString(vehicleNumber:number) {
    return LATERAL_POSITION_MAP[vehicleNumber];
}

export function vehicleTypeImage(vehicleNumber: Number, axleNumber:string, lateralPosition:string) {
    console.log(`vehicleNumber: ${vehicleNumber}, axleNumber: ${axleNumber.padStart(2, "0")}, lateralPosition: ${lateralPosition}`);
    const position = axleNumber.padStart(2, "0") + lateralPosition;
    if(vehicleNumber === 1) {
        return <VehicleType01Image position={position} />
    } else if(vehicleNumber === 2) {
            return <VehicleType02Image position={position} />
    } else if(vehicleNumber === 3) {
            return <VehicleType03Image position={position} />
    } else if(vehicleNumber === 4) {
        return <VehicleType04Image position={position} />
    } else if(vehicleNumber === 5) {
        return <VehicleType05Image position={position} />
    } else if(vehicleNumber === 6) {
        return <VehicleType06Image position={position} />
    } else if(vehicleNumber === 7) {
        return <VehicleType07Image position={position} />
    } else if(vehicleNumber === 8) {
        return <VehicleType08Image position={position} />
    } else if(vehicleNumber === 9) {
        return <VehicleType08Image position={position} />
    } else if(vehicleNumber === 10) {
        return <VehicleType10Image position={position} />
    } else if(vehicleNumber === 11) {
        return <VehicleType11Image position={position} />
    }
    return <></>;
}

export function tirePositionNumber(vehicleNumber: number, axleNumber: string, lateralPosition: string) {
    console.log(`[tirePositionNumber] vehicleType: ${vehicleNumber-1}, axleNumber: ${axleNumber}, lateralPosition: ${lateralPosition}`);
    let position = axleNumber.padStart(2, "0") + lateralPosition;
    return TIRE_POSITION_MAP[vehicleNumber-1][position]
}



export type WarningMessageInfo = {
    type: string
    dataKind: string
    message: string
}
export const getWarningList = (data: AbnormalVehicleInfo):WarningMessageInfo[] => {
    let warnings:WarningMessageInfo[] = [];
    if(data.pressure_info.pressure_alert.count > 0){
        warnings.push(WarningMessageInfoDefine.PressureAlert);
    }
    if(data.pressure_info.slow_punc.count > 0) {
        warnings.push(WarningMessageInfoDefine.SlowPunc);
    }
    if(data.pressure_info.pressure_drop.count > 0) {
        warnings.push(WarningMessageInfoDefine.PressureDrop);
    }
    if(data.temperature_info.temperature_alert.count > 0) {
        warnings.push(WarningMessageInfoDefine.TemperatureAlert);
    }
    if(data.temperature_info.temperature_caution.count > 0) {
        warnings.push(WarningMessageInfoDefine.TemperatureCaution);
    }
    return warnings;
}